import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import "./Works.css";
function Works() {
    const categories = [
      { name: "Pintura", path: "/obras/pintura", image: "/images/pintura.jpg" },
      { name: "Técnica Mixta", path: "/obras/tecnica-mixta", image: "/images/tecnicamixta.jpg" },
      { name: "Escultura", path: "/obras/escultura", image: "/images/escultura.png" },
      { name: "Ilustración Digital", path: "/obras/ilustracion-digital", image: "/images/ilustraciondigital.jpg" },
    ];
  
    return (
      <motion.div
        className="works-container"
        initial={{ opacity: 0, y: 50 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0, y: 50 }}
        transition={{ duration: 0.5, ease: "easeOut" }}
      >
        <h1 className="works-title">Obras</h1>
        <div className="works-grid">
          {categories.map((category, index) => (
            <Link
              key={index}
              to={category.path}
              className="works-card"
              style={{ backgroundImage: `url(${category.image})` }}
            >
              <h2 className="card-title">{category.name}</h2>
            </Link>
          ))}
        </div>
      </motion.div>
    );
  }
  
  export default Works;